<!-- SignaturePad.vue -->
<template>
  <div>
    <div class="signature-pad-wrapper">
      <canvas ref="signaturePad" class="signature-pad" width="400" height="200" @mouseup="saveSignature" @touchend="saveSignature"></canvas>
    </div>
    <button class="btn orcaBtn grey_bg sm_btn" @click.prevent="clearSignature">Clear</button>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad'; 

export default {
  mounted() {
    this.initSignaturePad(); 
  },
  methods: {
    initSignaturePad() {
      this.signaturePad = new SignaturePad(this.$refs.signaturePad, {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        penColor: 'rgb(0, 0, 0)'
      });
    },
    clearSignature() {
      this.signaturePad.clear(); 
      this.$emit('signature-updated', ''); 
    },
    saveSignature() {
      const imageData = this.signaturePad.toDataURL(); 
      this.$emit('signature-updated', imageData); 
    }
  }
};
</script>

<style scoped>
.signature-pad-wrapper {
  position: relative;
  width: 400px;
  height: 200px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: solid 1px #ddd;
  margin: 10px 0px;
}
.signature-pad {
  position: absolute;
  left: 0;
  top: 0;
  width:400px;
  height:200px;
}
textarea {
  width: 100%;
  min-height: 100px;
}
</style>
